import { MantineTheme } from "@mantine/core";

export type ThemeGradientBackground = "golden" | "blue" | "green" | "disabled";
export const themeGradientBackground = (
  theme: MantineTheme,
  variant?: ThemeGradientBackground
) => {
  if (variant === "golden") {
    return {
      background: theme.colors.golden[0],
    };
  }
  if (variant === "blue") {
    return {
      background: theme.colors.dusk[0],
    };
  }
  if (variant === "green") {
    return {
      background: theme.colors.greenIce[4],
    };
  }
  if (variant === "disabled") {
    return {
      background: theme.colors.grayIce[7],
    };
  }
};
